/* eslint-disable import/prefer-default-export */
import * as AutocompleteActions from '@src/redux/actions/autocomplete.actions'
import * as FilterActions from '@src/redux/actions/filter.actions'
import * as ActionTypes from '@src/redux/actionTypes'
import { defaultState } from './default.state'

export type AutocompleteActionType =
  | AutocompleteActions.ActionTypes
  | FilterActions.ActionTypes

export function reducer(state = defaultState, action: AutocompleteActionType) {
  switch (action.type) {
    case ActionTypes.Autocomplete.SEARCH_RESULTS_SUCCESS: {
      const {
        table,
        hasNext,
        hasPrev,
        autoCompleteRespType,
        sqlQueryUserUsage
      } = action.payload
      return {
        ...state,
        table,
        hasNext,
        hasPrev,
        autoCompleteRespType:
          autoCompleteRespType || defaultState.autoCompleteRespType,
        sqlQueryUserUsage: sqlQueryUserUsage || defaultState.sqlQueryUserUsage
      }
    }
    case ActionTypes.Autocomplete.AUTOCOMPLETE_SEARCH_SUCCESS: {
      return {
        ...state,
        searchData: action.payload.searchData
      }
    }
    case ActionTypes.Autocomplete.SEARCH_QUERY_SAVE: {
      return {
        ...state,
        searchQuery: action.payload.searchQuery
      }
    }
    case ActionTypes.Autocomplete.REQUEST_PENDING: {
      return {
        ...state,
        isPending: action.payload.isPending
      }
    }
    case ActionTypes.Autocomplete.SET_SESSION:
    case ActionTypes.Autocomplete.CHANGE_BATCH_SIZE: {
      return {
        ...state,
        batchSize: action.payload.batchSize
      }
    }
    case ActionTypes.Autocomplete.DISPOSE: {
      return {
        ...state,
        sqlQueryUserUsage: defaultState.sqlQueryUserUsage,
        autoCompleteRespType: defaultState.autoCompleteRespType
      }
    }
    case ActionTypes.Autocomplete.DISPOSE_SESSION: {
      return {
        ...state,
        table: defaultState.table,
        sqlQueryUserUsage: defaultState.sqlQueryUserUsage,
        autoCompleteRespType: defaultState.autoCompleteRespType
      }
    }
    case ActionTypes.Filter.APPLY_NOW:
    case ActionTypes.Filter.RESET_ALL: {
      return {
        ...state,
        table: defaultState.table,
        sqlQueryUserUsage: defaultState.sqlQueryUserUsage,
        autoCompleteRespType: defaultState.autoCompleteRespType
      }
    }
    default:
      return state
  }
}
